import { MediaQualifierService } from '../api-services/qualifiers/MediaQualifier.service';

export class HyperLinkFormatter {
	static Format(row, cell, value, columnDef, dataContext): string {
		let target = '_blank';
		if (!value) {
			value = '';
		}
		if (!!columnDef.params) {
			if (!!columnDef.params.hrefTarget) {
				target = columnDef.params.hrefTarget;
			}
		}
		if (value.indexOf('https://media.simplelayers.com/') === 0) {

			const url = MediaQualifierService.ToFeatureImageString(value);
			return `<a href="preview-image" onClick="event.preventDefault();document.body.dispatchEvent(new CustomEvent('preview-media',{detail:{url:'${url}'}}));return false;">View Image</a> or <a href="${url}" target="_blank">Download File</a>`;

		}
		const html = '<a class="hyperlink-cell-readonly" href="' + value + '" target="' + target + '" >' + value + '</a>';
		return html;
	}
}
